import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { checkValid, setValueForm, updateValidate } from '../../../../../../helpers/form/FormHelper'
import { responseError } from '../../../../../../helpers/response/ResponseHelper'
import { addWriteOffActItem, editWriteOffActItem } from '../../../../../../store/writeOffSlice'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../../helpers/form/FormData'
import ErrorMessage from '../../../../../UI/messages/ErrorMessage'
import MyButton from '../../../../../UI/form/MyButton'
import { addWriteOffActItemAPI, editWriteOffActItemAPI } from '../../../../../../api/writeOff/writeOffActItemAPI'
import TextFieldMain from '../../../../../form/fields/TextFieldMain'
import UnitMeasureSelectMain from '../../../../../form/fields/UnitMeasureSelectMain'
import WriteOffActItemSearch from '../../../../forms/fileds/WriteOffActItemSearch'
import WriteOffActItemCountField from '../../../../acts/form/fields/WriteOffActItemCountField'

const WriteOffActItemForm = ({ writeOffActId, writeOffActItemBd, setOpen }) => {

    const writeOffAct = useSelector(state => state.writeOff.writeOffAct)
    const dispatch = useDispatch()

  	const [data, setData] = useState(writeOffActItemBd ? writeOffActItemBd : {}) // Дані з форми

    console.log('data', data)

    const [positionForWriteOff, setPositionForWriteOff] = useState(null) // Дані з форми
          
	const [valid, setValid] = useState({}) // Валідація кожного поля
	const [loading, setLoading] = useState(false)

	const [isValidForm, setIsValidForm] = useState(false) // Загальна валідація форми
	const [result, setResult] = useState('')
	const [error, setError] = useState('')

	useEffect(() => {
		checkValid(valid, setIsValidForm)
	}, [valid])

	const save = (e) => {
        e.preventDefault()
        const dataForBd = setDataForBd()

        console.log('dataForBd', dataForBd)

        setError('')
        setLoading(true)

        if (dataForBd.id) {
            edit(dataForBd)
        } else {
            add(dataForBd)
        }
    }

    const add = (dataForBd) => {
        addWriteOffActItemAPI(dataForBd).then(data => {
            dispatch(addWriteOffActItem(data))
            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

    const edit = (dataForBd) => {
        editWriteOffActItemAPI(dataForBd).then(data => {
            if (data) {
                dispatch(editWriteOffActItem(data))
            }
            setOpen(false)
            setLoading(false)
        }).catch(e => {
            setError(responseError(e))
            setLoading(false)
        })
    }

    const setDataForBd = () => {
        let dataForBd = {
            writeOffActId,
            name: data.name,
            count: data.count,
            unitMeasure: data.unitMeasure,
            reason: data.reason,
        }

        if (data.id) {
            dataForBd = {
                ...dataForBd,
                id: data.id
            }
        }

        return dataForBd
    }

  return (
    <div className='myFormSimple'>
        {
            data && data.id ? '' :
            formDataProductIsField('supplyBillItemId', 'writeOffActItem') ?
                <WriteOffActItemSearch 
                    departmentId={writeOffAct && writeOffAct.departmentId ? writeOffAct.departmentId : null}
                    required={formDataProductRequiredField('supplyBillItemId', 'writeOffActItem')}
                    setValidate={e => updateValidate(setValid, 'supplyBillItemId', e)}
                    setValueForm={e => setValueForm(setData, 'supplyBillItemId', e)}
                    forciblyValue={data && data.supplyBillItemId ? data.supplyBillItemId : ''}
                    setPositionForWriteOff={setPositionForWriteOff}
                    label='Назва'
                    placeholder='Введіть для пошуку від 3 символів'
                />
            : ''
        }
        {/* {
            formDataProductIsField('name', 'writeOffActItem') ?
                <TextFieldMain
                    required={formDataProductRequiredField('name', 'writeOffActItem')}
                    setValidate={e => updateValidate(setValid, 'name', e)}
                    setValueForm={e => setValueForm(setData, 'name', e)}
                    forciblyValue={data && data.name ? data.name : ''}
                    label='Назва'
                    placeholder='Введіть назву'
                />
            : ''
        } */}
        {
            data.supplyBillItemId ?
                <>
                    {
                        formDataProductIsField('count', 'writeOffActItem') ?
                            <WriteOffActItemCountField
                                item={
                                    positionForWriteOff ? positionForWriteOff :
                                    data.id && data.billItemWithWriteOff ? data.billItemWithWriteOff : null
                                }
                                addedWriteOff={
                                    data.id ? data.count : 0 // Якщо зміна кількості, то до загальної додаєму ту, що вже вказана в позиції
                                }
                                data={data}
                                required={formDataProductRequiredField('count', 'writeOffActItem')}
                                setValidate={e => updateValidate(setValid, 'count', e)}
                                setValueForm={e => setValueForm(setData, 'count', e)}
                                forciblyValue={
                                    data && data.count ? data.count : ''
                                }
                            />
                        : ''
                    }
                    {/* {
                        formDataProductIsField('unitMeasure', 'writeOffActItem') ?
                            <UnitMeasureSelectMain
                                required={formDataProductRequiredField('unitMeasure', 'writeOffActItem')}
                                setValidate={e => updateValidate(setValid, 'unitMeasure', e)}
                                setValueForm={e => setValueForm(setData, 'unitMeasure', e)}
                                forciblyValue={data && data.unitMeasure ? data.unitMeasure : ''}
                            />
                        : ''
                    } */}
                    {
                        formDataProductIsField('reason', 'writeOffActItem') ?
                            <TextFieldMain
                                required={formDataProductRequiredField('reason', 'writeOffActItem')}
                                setValidate={e => updateValidate(setValid, 'reason', e)}
                                setValueForm={e => setValueForm(setData, 'reason', e)}
                                forciblyValue={data && data.reason ? data.reason : ''}
                                label='Причина списання'
                                multiline={true}
                                rows={2}
                            />
                        : ''
                    }
                </>
            : ''
        }

        <ErrorMessage
            error={error}
        />

        <MyButton
            size='md'
            onClick={save}
            disabled={!isValidForm || loading ? true : false}
        >
            Зберегти
        </MyButton>
    </div>
  )
}

export default WriteOffActItemForm